import React from 'react';
import styled from 'styled-components';

import {Skeleton} from '../../../components/common/skeleton';
import {
  InputWidth,
  StyledCustomFieldFormWrapperDiv,
  StyledSettingsContent,
  StyledSettingsContentWrap,
  StyledSettingsField,
  TextareaWidth,
} from './customFieldForm';

/*
 * Styles.
 */

const StyledSpacer = styled.div<{$marginBottom: string}>`
  margin-bottom: ${(p) => p.$marginBottom};
`;

/*
 * Component.
 */

export const CustomFieldFormSkeleton = () => (
  <StyledCustomFieldFormWrapperDiv>
    <StyledSettingsContentWrap>
      <div>
        <StyledSpacer $marginBottom="30px" />
        <Skeleton width="80px" height="12px" />
        <StyledSpacer $marginBottom="4px" />
        <Skeleton width="170px" height="22px" />
        <StyledSpacer $marginBottom="30px" />

        <StyledSettingsContent>
          <StyledSettingsField>
            <Skeleton width={`${InputWidth}px`} height="50px" />
            <StyledSpacer $marginBottom="15px" />
          </StyledSettingsField>

          <StyledSettingsField>
            <Skeleton width={`${TextareaWidth}px`} height="75px" />
            <StyledSpacer $marginBottom="15px" />
          </StyledSettingsField>

          <StyledSettingsField>
            <Skeleton width={`${InputWidth}px`} height="50px" />
          </StyledSettingsField>
        </StyledSettingsContent>
      </div>
    </StyledSettingsContentWrap>
  </StyledCustomFieldFormWrapperDiv>
);
